import { IIconProps } from '~/types';

const NgnFlag = (props: IIconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1200" height="600" viewBox="0 0 6 3" {...props}>
    <title>Flag of Nigeria</title>
    <path fill="#008751" d="M0 0h6v3H0z" />
    <path fill="#fff" d="M2 0h2v3H2z" />
  </svg>
);
export default NgnFlag;
